import { TFunction } from 'i18next';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetWarehouseAddress } from '@steelbuy/data-access';
import { AddressType, getFormattedAddress } from '@steelbuy/ts-shared';
import { Tooltip, TooltipType } from '@steelbuy/ui-primitive';
import { useIsVendorFeatureSupported } from '@steelbuy/vendor';

export const CollectionAddressCell = ({
    addressId,
    onAddressLoaded,
}: {
    addressId: string;
    onAddressLoaded?: () => void;
}) => {
    const isThirdPartySupported = useIsVendorFeatureSupported('THIRD_PARTY_ADDRESSES');

    const addressType = isThirdPartySupported
        ? `${AddressType.WAREHOUSE}|${AddressType.THIRD_PARTY}`
        : AddressType.WAREHOUSE;

    const { data } = useGetWarehouseAddress({ addressType });
    const { t }: { t: TFunction } = useTranslation(['domainModel']);

    const addressInfo = data?.find((address) => address.id === addressId);

    useEffect(() => {
        if (addressInfo) {
            onAddressLoaded?.();
        }
    }, [addressInfo]);

    if (!addressInfo) return null;

    const formattedAddressParts = getFormattedAddress({
        addressLine1: addressInfo.addressLine1,
        city: addressInfo.city,
        name: addressInfo?.name,
        postalCode: addressInfo?.postalCode,
        country: addressInfo?.country,
        state: addressInfo?.state,
    }).map(({ value, isEnum }) => (isEnum ? t(`domainModel:${value}`) : value));

    const formattedAddress =
        formattedAddressParts.length > 1 ? `${formattedAddressParts.join(', ')}` : formattedAddressParts[0] ?? '';

    return (
        <Tooltip content={formattedAddress} type={TooltipType.INFO}>
            <td className="bulk-listing-table__table__has-max-width">{formattedAddress}</td>
        </Tooltip>
    );
};
